import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoBebida: [],
  },

  getters: {
    getTipoBebida: (state) => state.tipoBebida,
  },

  mutations: {
    SET_TIPO_BEBIDA(state, tipoBebida) {
      state.tipoBebida = tipoBebida;
    },
  },

  actions: {
    async fetchTipoBebida({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTipoBebida')
        .then((response) => {
          commit('SET_TIPO_BEBIDA', response.data.data);
        });
    },
  },
};
